import get from "lodash/get"
import values from 'lodash/values';
import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import createModelApi from "~/backend/modelApi";
import {getGlobalAction, getModelName} from "~/stateGetter";
import {fetchTableResults} from './tableResults';
import {modify} from "mythil/object";
import invalidateLoadedModels from "~/reducers/helpers/invalidateLoadedModels";
import {openActionResult} from "~/actions/navigation_actions";
import identify from "~/identify";
import authenticatedRequest from "~/backend/authenticatedRequest";
import {getResultQueryParams, getResultQueryParamsWithSelectedRows, getSaveValues} from "~/statePresenter";
import { getCustomActionResult } from "../../stateGetter";

const customAction = createSuccessPromiseThunk({
    func: async ({modelId, actionName, data, getState, dispatch, getConfig}) => {
        let state = getState(),
            modelApi = createModelApi(
                getConfig().baseUrl,
                getModelName(state, modelId),
                (foo) => authenticatedRequest(foo, dispatch)
            ),
            requiresSelection = get(getGlobalAction(state, modelId, actionName), "requires_selection"),
            queryParams = requiresSelection ? getResultQueryParamsWithSelectedRows(state, modelId) : getResultQueryParams(state, modelId),
            saveValues = getSaveValues(state, modelId);

        let actionResult = await modelApi.performCustomAction(actionName, queryParams, { ...saveValues, ...data });

        if(!actionResult.success) { return actionResult; }

        dispatch(openActionResult(actionResult));

        return actionResult;
    },
    name: 'customAction',
});

let execute = customAction.execute;
customAction.execute = (modelId, actionName, data) => execute({modelId, actionName, data}, {modelId, actionName});

let reduce = customAction.reduce;
customAction.reduce = (model, action) => {
    model = modify(model, 'customActionResult', (state) => {
        switch(action.type) {
            case customAction.types.SUCCESS:
                state = {
                    actionName: action.actionName,
                    ...state,
                    finished_at: Date.now(),
                    status: identify.STATUS_SUCCESS,
                    value: {
                        messages: action.value.messages
                    }
                };
                break;
            default:
                state = reduce(state, action);
                break;
        }

        if(values(customAction.types).indexOf(action.type) > -1) {
            state = { ...state, actionName: action.actionName };
        }

        return state;
    });

    return model;
};

customAction.reduceState = (state, action) => {
    switch(action.type) {
        case customAction.types.SUCCESS:
            let itemAction = getGlobalAction(state, action.modelId, action.actionName);
            if(!itemAction.noReload) {
                return invalidateLoadedModels(state);
            }
        default:
            return state;
    }
};

const reduceCustomAction = customAction.reduce,
    CUSTOM_ACTION_TYPES = customAction.types,
    performCustomAction = customAction.execute,
    reduceCustomActionState = customAction.reduceState,
    performCustomScanQrAction = (...args) => {
        return async (dispatch, getState) => {
            await dispatch(customAction.execute(...args));
            const {status} = getCustomActionResult(getState(), args[0]);
            return status === identify.STATUS_SUCCESS;
        }
    };

export {
    reduceCustomAction,
    CUSTOM_ACTION_TYPES,
    performCustomAction,
    reduceCustomActionState,
    performCustomScanQrAction
}